import { PERMISSION } from 'constants/accountSettingPermission';
import { FLIGHT_ROUTE_MODULES } from 'constants/flightBooking';
import { showToastError } from 'utils';

const findPermissionItem = (items, href) => {
  const findMatch = (item) => item.path === href
  || (Array.isArray(item.path) && item.path.includes(href));

  const directMatch = items.find(findMatch);
  if (directMatch) {
    return { item: directMatch, matchedPath: href };
  }

  return items.reduce((result, item) => {
    if (result) return result;

    if (item.children) {
      const childMatch = item.children.find(findMatch);
      if (childMatch) {
        return { item, childItem: childMatch, matchedPath: href };
      }

      const nestedMatch = findPermissionItem(item.children, href);
      if (nestedMatch) return nestedMatch;
    }

    return null;
  }, null);
};

export const checkHasPermission = (myPermission, href) => {
  // Intranet my-permission is modules[]; only pages mapped to a module are gated.
  if (Array.isArray(myPermission)) {
    const requiredModules = FLIGHT_ROUTE_MODULES[href];
    return !requiredModules || requiredModules.some((module) => myPermission.includes(module));
  }

  // Past this point my-permission is an extranet accountSetting object. The flight pages are
  // intranet-only on the BE, and no accountSetting node covers them, so close them here too.
  if (FLIGHT_ROUTE_MODULES[href]) return false;

  const permissionMatch = findPermissionItem(PERMISSION, href);

  if (myPermission.accountSetting && permissionMatch) {
    const { item, childItem } = permissionMatch;

    const checkPermissionValue = (permItem, childPermItem) => {
      if (childPermItem) {
        return myPermission.accountSetting[permItem.value][childPermItem.value];
      }

      if (typeof myPermission.accountSetting[permItem.value] === 'boolean') {
        return myPermission.accountSetting[permItem.value];
      }

      if (permItem.children) {
        return permItem.children
          .some((child) => myPermission.accountSetting[permItem.value][child.value]);
      }

      return false;
    };

    return checkPermissionValue(item, childItem);
  }

  return true;
};

export const onClickLink = (e, myPermission) => {
  const href = e.currentTarget.getAttribute('href').split('?')[0];

  const hasPermission = checkHasPermission(myPermission, href);

  if (!hasPermission) {
    e.preventDefault();
    showToastError('Bạn không có quyền truy cập');
  }
};
